import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { PS, T } from '../../lib/theme';

const TABS = [
  { path: '/settings/vending', label: 'Vending' },
  { path: '/settings/tables', label: 'Tables' },
  { path: '/settings/club-hours', label: 'Club hours' },
  { path: '/settings/climate', label: 'Climate' },
  { path: '/settings/display-devices', label: 'Display devices' },
] as const;

export function SettingsPage() {
  const { pathname } = useLocation();

  return (
    <section aria-labelledby="settings-heading">
      <h1 id="settings-heading" style={{ ...T.sectionTitle, color: PS.nearBlack, margin: '0 0 16px' }}>
        Settings
      </h1>
      <div
        role="tablist"
        aria-label="Settings"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 4,
          marginBottom: 24,
          borderBottom: `1px solid ${PS.border}`,
        }}
      >
        {TABS.map((tab) => {
          const selected = pathname === tab.path || (pathname === '/settings' && tab.path === '/settings/vending');
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              role="tab"
              aria-selected={selected}
              style={{
                ...T.navLink,
                color: selected ? PS.white : PS.tealDeep,
                background: selected ? PS.tealDeep : PS.pageSecondary,
                border: `1px solid ${selected ? PS.tealDeep : PS.border}`,
                borderBottom: selected ? `1px solid ${PS.tealDeep}` : `1px solid ${PS.border}`,
                borderRadius: '3px 3px 0 0',
                padding: '10px 14px',
                minHeight: 44,
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
              }}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>
      <div role="tabpanel" aria-label="Selected settings section">
        <Outlet />
      </div>
    </section>
  );
}
